import { loadJs } from 'bits/load'

declare global {
  interface Window {
    FrontChat: (command, options) => void
  }
}

interface FrontChatInitPayload {
  chatId: string
  useDefaultLauncher?: boolean
  email?: string
  userHash?: string
}

export function showChatWidget({ email, userHash }): void {
  const payload: FrontChatInitPayload = { chatId: 'c399c87a1d63853a0941b99dc39e192f', useDefaultLauncher: true }
  if (email && userHash) {
    payload.email = email
    payload.userHash = userHash
  }

  loadJs('https://chat-assets.frontapp.com/v1/chat.bundle.js').then((): void => {
    window.FrontChat('init', payload)
  })
}
